import { CHANNEL_LAYOUT_VALUES } from '../app-settings/constants/channel-layout-values';

export default {
  [CHANNEL_LAYOUT_VALUES.CLASSIC]: 'classic',
  [CHANNEL_LAYOUT_VALUES.STRIP]: 'strip',
  [CHANNEL_LAYOUT_VALUES.COMPACT]: 'compact',
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/layouts-map.js